import styled from 'styled-components';
import {getColorFromTheme} from '@ui/ui-utils';

export const Wrapper = styled.div`
  @media (max-width: 500px) {
    margin: 0px;
  }
  .header {
   
    width: 100%;

    display: flex;
    align-items: center;
    @media (max-width: 500px) {
      padding: 14px 12px 20px;
    }
  }
  
    .table {
      width: 100%;
      margin-top: 24px;
      background-color: white;
      border: 1px solid #ededf2;
      border-radius: 10px;
      .table-desc {
      
        padding: 16px 24px ;
      }
    }
  }
`;
export const TableContainer = styled.div`
  border-top: 1px solid #ededf2;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  max-width: 100%;
  overflow-x: hidden;
`;

export const ItemLoaderWrapper = styled.div`
  padding: 28px 12px 32px 22px;
  justify-content: center;
  width: 100%;
  border-top: 1px solid #ededf2;
`;

export const ItemWrapperContainer = styled.div``;

export const ItemWrapper = styled.div`
  display: grid;
  grid-template-columns: 32% 30% 20% 15%;
  padding: 16px;
  border-top: 1px solid ${getColorFromTheme('borderLight')};
  align-items: center;
  p {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;
export const LoadingWrapper = styled.div`
  border: 1px solid #ededf2;
  border-radius: 10px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const SecondRowWrapper = styled.div`
  width: 100%;

  max-width: 100%;
  overflow-x: auto;
  display: grid;
  &::-webkit-scrollbar {
    width: 2em;
    border-top: 1px solid #ededf2;
    height: 2.1em;
  }

  &::-webkit-scrollbar-track {
    background: #f6f8fa;
    border: 0.8em solid rgba(0, 0, 0, 0);
    background-clip: padding-box;

    -webkit-border-radius: 1.5em;

    border-radius: 100px;
  }

  &::-webkit-scrollbar-thumb {
    height: 10em;
    border: 0.8em solid rgba(0, 0, 0, 0);
    background: #e5ebf1;
    border-radius: 10px;
    background-clip: padding-box;
    -webkit-border-radius: 1.5em;

    -webkit-box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.025);
  }

  &::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }

  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }
  div.header {
    min-width: 718px;
  }
`;

export const HeadlineWrapper = styled.div`
  display: grid;
  width: 100%;

  grid-template-columns: 35% 25% 20% 15%;
  padding-left: 16px;
`;

export const HeadlineWrapperContainer = styled.div`
  display: block;

  padding: 16px 16px 12px 0px;
  background-color: ${getColorFromTheme('backgroundLight')};
  white-space: nowrap;
  height: 52px;
`;

export const Overview = styled.div`
  padding: 16px;

  border: 1px solid #ededf2;
  border-radius: 10px;
  background-color: white;
  .cards {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media (max-width: 768px) {
      flex-direction: column;
    }
    .card {
      border: 1px solid #ededf2;
      border-radius: 10px;
      padding: 8px 16px;
      display: flex;
      min-width: 48%;
      align-items: center;
      justify-content: space-between;
      @media (max-width: 768px) {
        width: 100%;
        margin-bottom: 10px;
      }

      .number {
        padding: 6px 12px;
        background: #ededf2;
        border-radius: 8px;
      }
    }
  }
`;
